import React from "react";
const Dashboardevents = (props) => {
  return (
    <div
      className={`xs:p-1 sm:p-2 lg:p-2 flex justify-between flex-col cursor-pointer items-center xs:w-36 sm:w-40 lg:w-60 xs:rounded-2xl rounded-2xl sm:rounded-3xl`}
      onClick={props.onClick}
    >
      <img
        src={props.eventthubmail}
        className={`w-full xs:h-40 sm:h-36 lg:h-52 rounded-[18px]`}
        alt="eventthubmail"
      />
      <div
        className={`flex justify-center items-center flex-col xs:pt-2 sm:pt-2 lg:pt-3 leading-tight`}
      >
        <p
          className={`uppercase text-secondary font-onestRegular text-center xs:!text-[10px] line-clamp-2 sm:text-xs lg:text-sm xs:leading-4 leading-tight ${props.textclassName}`}
        >
          {props.eventTitle}
        </p>
        <div className="flex items-center xs:gap-1 lg:gap-2 xs:mt-1 sm:mt-1.5">
          <p className=" font-onestMedium xs:!text-[8px] sm:!text-[10px] lg:text-xs text-goldMetallic ">
            {props.evetDate}
          </p>
          <p className=" font-onestMedium xs:!text-[8px] sm:!text-[10px] lg:text-xs text-goldMetallic">
            {props.eventDis}
          </p>
        </div>
      </div>
    </div>
  );
};
export default Dashboardevents;
